import { ValueOfKey } from '../../../utils-types';

export const LOCAL_STORAGE_KEYS = {
  PRE_CHECK_IN_USER_DATA: 'PRE_CHECK_IN_USER_DATA',
  ENABLED_MODULES: 'ENABLED_MODULES',
  AVAILABLE_MODULES: 'AVAILABLE_MODULES',
  LOGGED_IN_USER: 'loggedInUser',
  IS_ENTITY_HAS_CHILD: 'IS_ENTITY_HAS_CHILD',
  PAYMENT_FLOW_TYPE: 'PAYMENT_FLOW_TYPE',
  BILLING_TYPE: 'BILLING_TYPE',
  SOLUTION_TYPE_FLAGS: 'SOLUTION_TYPE_FLAGS',
  ACTIVE_SOLUTION: 'ACTIVE_SOLUTION',
  USER_NAV_LINKS: 'USER_NAV_LINKS',
} as const;

export type LocalStorageKeys = ValueOfKey<typeof LOCAL_STORAGE_KEYS>;
